import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { PageBanner } from "../components/PageBanner";
import { CTABand } from "../components/CTABand";
import { Services } from "../components/home/Services";

export default function ServicesPage() {
  return (
    <div data-testid="services-page">
      <Header />
      <main>
        <PageBanner
          testId="services-banner"
          eyebrow="What We Do"
          title="Our Services"
          description="A complete range of personalized home care services — from daily living assistance and companionship to specialized dementia, palliative, and 24-hour care."
        />
        <Services />
        <CTABand />
      </main>
      <Footer />
    </div>
  );
}
